<template>
  <div :class="`app-wrapper lo_tb ${theme}`" style="width:100vw;height:100vh;overflow: hidden;">
    <Navbar :navbar_status="navbar_status"/>
    <div :style="`height:${navbar_status.show==true?'calc(100% - 100px)':'calc(100% - 60px)'};width:100%;overflow:hidden;`">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Navbar from '@/views/layout_tb/Navbar.vue'
import {fun_load_theme, fun_save_dict} from "@/utils/common.js";
import {querySysDictInfo} from "@/api/sys";

export default {
  name: 'Index',
  components: {Navbar},
  data() {
    return {
      theme:'theme_default',
      current_user:{},
      navbar_status:{show:false,current_code:'',menus:[]},
    };
  },
  methods: {
    fun_load_css(_theme) {
      fun_load_theme('tb_'+_theme);
    },
  },
  mounted() {
    querySysDictInfo({pageSize:999999}).then(res => {fun_save_dict(res.rows)})
    const _theme = localStorage.getItem("theme_name");
    if(_theme) this.fun_load_css(_theme);
  }
};
</script>

<style>
</style>
